var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_3535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3021 20.8729V27.4425C31.3021 29.1336 30.0856 30.5897 28.4084 30.8123C25.1823 31.2405 21.8914 31.4615 18.5494 31.4615C15.2074 31.4615 11.9164 31.2405 8.69034 30.8123C7.01317 30.5897 5.79663 29.1336 5.79663 27.4425V20.8729M31.3021 20.8729C31.6692 20.5539 31.9628 20.1593 32.163 19.7161C32.3631 19.2729 32.4649 18.7916 32.4614 18.3053V12.4576C32.4614 10.7866 31.2743 9.34288 29.6218 9.09555C27.8709 8.83341 26.1112 8.63388 24.3461 8.49733M31.3021 20.8729C31.0022 21.128 30.6529 21.3289 30.2618 21.4603C26.4842 22.7137 22.5294 23.3505 18.5494 23.3462C14.4561 23.3462 10.519 22.683 6.83695 21.4603C6.45554 21.3334 6.10228 21.134 5.79663 20.8729M5.79663 20.8729C5.42958 20.5539 5.1359 20.1593 4.93578 19.7161C4.73566 19.2729 4.63383 18.7916 4.63729 18.3053V12.4576C4.63729 10.7866 5.82446 9.34288 7.4769 9.09555C9.22781 8.83341 10.9875 8.63388 12.7527 8.49733M24.3461 8.49733V7.1154C24.3461 6.19297 23.9796 5.30832 23.3274 4.65607C22.6751 4.00381 21.7905 3.63738 20.8681 3.63738H16.2307C15.3083 3.63738 14.4236 4.00381 13.7714 4.65607C13.1191 5.30832 12.7527 6.19297 12.7527 7.1154V8.49733M24.3461 8.49733C20.4874 8.19911 16.6114 8.19911 12.7527 8.49733M18.5494 18.7088H18.5617V18.7212H18.5494V18.7088Z",
    stroke: "#959595",
    strokeWidth: 2.31868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_3535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.0989,
    height: 37.0989,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.c7559b5570b97f00e85ce5a8fe5381db.svg";
export { ForwardRef as ReactComponent };